import React, { useEffect, useState } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const MuiCheckBox = ({id, description, value, onChange}) => {
    const [checked, setChecked] = useState(value);

    useEffect(() => {
        // we may not have the correct value on the initial render so use this effect to ensure the latest state is set
        setChecked(value);
    }, [value])

    const toggle = () => {
        const value = !checked;
        setChecked(value);
        onChange(id, value);
    }

    // console.log('fubar', checked, value, id, description)

    return <FormControlLabel
        control={
            <Checkbox
                checked={checked}
                onChange={toggle}
                color="primary"
            />
        }
        label={description}
    />
}

export default MuiCheckBox;


